var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "join-row-wrap"
  }, [_c('div', {
    staticClass: "join-row join-row--form"
  }, [_vm._m(0), _c('div', {
    staticClass: "board-table board-table--input",
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    attrs: {
      "role": "rowgroup"
    }
  }, [_c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    staticClass: "align-center",
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("아이디")]), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.username,
      expression: "user.username"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "text",
      "name": "username"
    },
    domProps: {
      "value": _vm.user.username
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "username", $event.target.value);
      }, _vm.input]
    }
  })])]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    staticClass: "align-center",
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("비밀번호")]), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.password,
      expression: "user.password"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": _vm.user.password
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value);
      }, _vm.input]
    }
  }), _c('p', {
    staticClass: "d-block text-grey mt-4 font-size-10 font-size-lg-12"
  }, [_vm._v("* (영문대소문자/숫자/특수문자 조합, 8 - 16자)")])])]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    staticClass: "align-center",
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("비밀번호 확인")]), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.passwordConfirm,
      expression: "user.passwordConfirm"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "password",
      "name": "password2"
    },
    domProps: {
      "value": _vm.user.passwordConfirm
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "passwordConfirm", $event.target.value);
      }, _vm.input]
    }
  })])]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_vm._m(1), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('v-radio-group', {
    staticClass: "my-0 py-0",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "height": "45px"
    },
    attrs: {
      "row": "",
      "hide-details": "",
      "dense": ""
    },
    model: {
      value: _vm.user.kind,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "kind", $$v);
      },
      expression: "user.kind"
    }
  }, _vm._l(_vm.kinds, function (kind) {
    return _c('v-radio', {
      key: kind.value,
      attrs: {
        "label": kind.text,
        "value": kind.value
      }
    });
  }), 1)], 1)]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_vm._m(2), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.name,
      expression: "user.name"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": _vm.user.name
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value);
      }, _vm.input]
    }
  })])]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_vm._m(3), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.affiliation,
      expression: "user.affiliation"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "text",
      "name": "affiliation"
    },
    domProps: {
      "value": _vm.user.affiliation
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "affiliation", $event.target.value);
      }, _vm.input]
    }
  })])]), !_vm.isSupporter ? [_c('div', {
    attrs: {
      "role": "row"
    }
  }, [_vm._m(4), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.bornAt,
      expression: "user.bornAt"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.user.bornAt
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "bornAt", $event.target.value);
      }
    }
  })])]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_vm._m(5), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('v-radio-group', {
    staticClass: "my-0 py-0",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "height": "45px"
    },
    attrs: {
      "row": "",
      "hide-details": "",
      "dense": ""
    },
    model: {
      value: _vm.user.gender,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "gender", $$v);
      },
      expression: "user.gender"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "남성",
      "value": "남성"
    }
  }), _c('v-radio', {
    attrs: {
      "label": "여성",
      "value": "여성"
    }
  })], 1)], 1)]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_vm._m(6), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('v-select', {
    staticClass: "select my-0 py-0",
    attrs: {
      "items": _vm.regions,
      "hide-details": "",
      "dense": ""
    },
    model: {
      value: _vm.user.region,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "region", $$v);
      },
      expression: "user.region"
    }
  })], 1)]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    staticClass: "align-center",
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("연락처")]), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.phone1,
      expression: "user.phone1"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "tel",
      "name": "phone1",
      "maxlength": "4"
    },
    domProps: {
      "value": _vm.user.phone1
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "phone1", $event.target.value);
      }, _vm.input]
    }
  })]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.phone2,
      expression: "user.phone2"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "tel",
      "name": "phone2",
      "maxlength": "4"
    },
    domProps: {
      "value": _vm.user.phone2
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "phone2", $event.target.value);
      }, _vm.input]
    }
  })]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.phone3,
      expression: "user.phone3"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "tel",
      "name": "phone3",
      "maxlength": "4"
    },
    domProps: {
      "value": _vm.user.phone3
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "phone3", $event.target.value);
      }, _vm.input]
    }
  })])], 1)], 1)]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    staticClass: "align-center",
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("이메일")]), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.email1,
      expression: "user.email1"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "text",
      "name": "email1"
    },
    domProps: {
      "value": _vm.user.email1
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email1", $event.target.value);
      }
    }
  })]), _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("@")]), _c('v-col', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.email2,
      expression: "user.email2"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "text",
      "name": "email2"
    },
    domProps: {
      "value": _vm.user.email2
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email2", $event.target.value);
      }
    }
  })]), _c('v-col', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.email3,
      expression: "user.email3"
    }],
    staticClass: "select w-100",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.user, "email3", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, function ($event) {
        _vm.user.email2 = _vm.user.email3;
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("직접입력")]), _c('option', {
    domProps: {
      "value": "naver.com"
    }
  }, [_vm._v("naver.com")]), _c('option', {
    domProps: {
      "value": "daum.net"
    }
  }, [_vm._v("daum.net")]), _c('option', {
    domProps: {
      "value": "google.com"
    }
  }, [_vm._v("google.com")])])])], 1)], 1)])] : _vm._e(), _vm.isSupporter ? _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_vm._m(7), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, _vm._l(_vm.areas, function (parent) {
    return _c('v-col', {
      key: parent._id,
      attrs: {
        "cols": "6",
        "lg": ""
      }
    }, [_c('v-row', [_c('v-col', [_vm._v(_vm._s(parent.name))])], 1), _vm._l(parent.children, function (child) {
      return _c('v-row', {
        key: child._id
      }, [_c('v-col', [_c('v-checkbox', {
        staticClass: "my-0 py-0",
        attrs: {
          "label": child.name,
          "value": child._id,
          "hide-details": "",
          "dense": ""
        },
        on: {
          "input": _vm.input
        },
        model: {
          value: _vm.user._areas,
          callback: function callback($$v) {
            _vm.$set(_vm.user, "_areas", $$v);
          },
          expression: "user._areas"
        }
      })], 1), child.name == '기타(입력)' && _vm.user._areas.includes(child._id) ? _c('v-col', {
        staticClass: "pt-0",
        attrs: {
          "cols": "12"
        }
      }, [_c('v-text-field', {
        staticClass: "my-0 py-0",
        attrs: {
          "hide-details": "",
          "dense": "",
          "outlined": ""
        },
        model: {
          value: _vm.user.areas_manual[parent._id],
          callback: function callback($$v) {
            _vm.$set(_vm.user.areas_manual, parent._id, $$v);
          },
          expression: "user.areas_manual[parent._id]"
        }
      })], 1) : _vm._e()], 1);
    })], 2);
  }), 1)]) : _vm._e()], 2)])])]), _c('div', {
    staticClass: "button-group"
  }, [_c('v-btn', {
    staticClass: "min-w-120px min-w-lg-200px",
    attrs: {
      "large": "",
      "outlined": "",
      "rounded": "",
      "color": "grey",
      "elevation": "0"
    },
    on: {
      "click": function click($event) {
        return _vm.cancel();
      }
    }
  }, [_c('span', {
    staticClass: "color-grey"
  }, [_vm._v("취소하기")])]), _c('v-btn', {
    staticClass: "min-w-120px min-w-lg-200px",
    attrs: {
      "large": "",
      "rounded": "",
      "color": "primary",
      "elevation": "0"
    },
    on: {
      "click": function click($event) {
        return _vm.submit();
      }
    }
  }, [_c('span', [_vm._v("회원가입")])])], 1), _c('daum-postcode', {
    ref: "daum-postcode",
    on: {
      "change": function change(_ref) {
        var postcode = _ref.postcode,
          address = _ref.address;
        return ((_vm.user.postcode = postcode) || true) && ((_vm.user.address1 = address) || true);
      }
    }
  })], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "join-caption join-caption--center"
  }, [_c('h3', {
    staticClass: "text-20 text-lg-18"
  }, [_vm._v("회원정보 필수입력")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "align-center",
    attrs: {
      "role": "columnheader"
    }
  }, [_c('span', [_vm._v("가입유형")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "align-center",
    attrs: {
      "role": "columnheader"
    }
  }, [_c('span', [_vm._v("이름")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "align-center",
    attrs: {
      "role": "columnheader"
    }
  }, [_c('span', {
    staticClass: "my-md-n3"
  }, [_vm._v("소속/부서"), _c('br', {
    staticClass: "d-none d-md-inline"
  }), _vm._v("(학교/학과)")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "align-center",
    attrs: {
      "role": "columnheader"
    }
  }, [_c('span', [_vm._v("생년월일")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "align-center",
    attrs: {
      "role": "columnheader"
    }
  }, [_c('span', [_vm._v("성별")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "align-center",
    attrs: {
      "role": "columnheader"
    }
  }, [_c('span', [_vm._v("지역")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "align-center",
    attrs: {
      "role": "columnheader"
    }
  }, [_c('span', [_vm._v("자문분야")])]);
}]

export { render, staticRenderFns }